<div class="p-6 space-y-6" id="page-perfil">
  <div>
    <h2 class="text-xl font-bold text-gray-900 dark:text-white">Mi Perfil</h2>
    <p class="text-sm text-gray-400 dark:text-gray-500">Edición de datos del gestor</p>
  </div>
  <div class="lg:grid-cols-3 grid grid-cols-1 gap-6">
    <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-sm text-center border border-gray-100
              dark:border-gray-800 p-6">
      <div class="mb-4 relative inline-block">
        <img alt="avatar" src="/img/default-avatar.png" class="object-cover ring-1 ring-gray-200
                  dark:ring-primary/20 w-24 h-24 rounded-2xl mx-auto" />
        <button type="button" class="btn btn-primary btn-square btn-sm absolute -bottom-2 -right-2">
          <svg class="w-4 h-4 text-white"><use href="/svg/sprite.svg#image-upload-icon"/></svg>
        </button>
      </div>
      <h3 class="font-bold text-gray-900 text-lg dark:text-white">Lic. Carlos Méndez</h3>
      <p class="text-sm text-primary font-medium">Gestor Senior</p>
      <p class="text-xs text-gray-400 mt-1">GestorMX Consultores · CDMX</p>
      <div class="mt-5 grid grid-cols-2 gap-3">
        <div class="bg-gray-50 dark:bg-gray-800 rounded-xl p-3">
          <p class="text-xl font-bold text-gray-800 dark:text-white">12</p>
          <p class="text-xs text-gray-400">Proyectos</p>
        </div>
        <div class="bg-gray-50 dark:bg-gray-800 rounded-xl p-3">
          <p class="text-xl font-bold text-gray-800 dark:text-white">48</p>
          <p class="text-xs text-gray-400">Tareas</p>
        </div>
      </div>
    </div>
    <div class="lg:col-span-2 bg-white dark:bg-gray-900 rounded-2xl shadow-sm border border-gray-100
              dark:border-gray-800 p-6">
      <h3 class="text-base font-bold text-gray-800 mb-5 dark:text-white">Información Personal</h3>
      <div class="md:grid-cols-2 grid grid-cols-1 gap-4">
        <div>
          <label class="text-xs font-semibold text-gray-400 tracking-wider mb-1.5 block dark:text-gray-500
                    uppercase">Nombre(s)</label>
          <label class="input w-full">
            <input value="Carlos" type="text" class="grow" />
          </label>
        </div>
        <div>
          <label class="text-xs font-semibold text-gray-400 tracking-wider mb-1.5 block dark:text-gray-500
                    uppercase">Apellidos</label>
          <label class="input w-full">
            <input value="Méndez Reyes" type="text" class="grow" />
          </label>
        </div>
        <div>
          <label class="text-xs font-semibold text-gray-400 tracking-wider mb-1.5 block dark:text-gray-500
                    uppercase">Correo electrónico</label>
          <label class="input w-full">
            <input value="carlos.mendez@gestormx.com" type="email" class="grow" />
          </label>
        </div>
        <div>
          <label class="text-xs font-semibold text-gray-400 tracking-wider mb-1.5 block dark:text-gray-500
                    uppercase">Teléfono</label>
          <label class="input w-full">
            <input value="+52 55 1234 5678" type="tel" class="grow" />
          </label>
        </div>
        <div>
          <label class="text-xs font-semibold text-gray-400 tracking-wider mb-1.5 block dark:text-gray-500
                    uppercase">Cédula / RFC</label>
          <label class="input w-full">
            <input value="MERC850412ABC" type="text" class="grow" />
          </label>
        </div>
        <div>
          <label class="text-xs font-semibold text-gray-400 tracking-wider mb-1.5 block dark:text-gray-500
                    uppercase">Especialidad</label>
          <select class="select w-full">
            <option selected="">Trámites de Construcción</option>
            <option>Trámites Mercantiles</option>
            <option>Trámites Ambientales</option>
            <option>Gestión Fiscal</option>
          </select>
        </div>
        <div class="md:col-span-2">
          <label class="text-xs font-semibold text-gray-400 tracking-wider mb-1.5 block dark:text-gray-500
                    uppercase">Dirección</label>
          <label class="input w-full">
            <input value="Av. Insurgentes Sur 1234, Col. Del Valle, CDMX" type="text" class="grow" />
          </label>
        </div>
      </div>
      <div class="mt-5 pt-5 border-t border-gray-100 dark:border-gray-800">
        <h4 class="text-sm font-bold text-gray-800 mb-4 dark:text-white">Cambiar Contraseña</h4>
        <div class="md:grid-cols-3 grid grid-cols-1 gap-4">
          <div>
            <label class="text-xs font-semibold text-gray-400 tracking-wider mb-1.5 block dark:text-gray-500
                      uppercase">Actual</label>
            <label class="input w-full">
              <input type="password" placeholder="••••••••" class="grow" />
            </label>
          </div>
          <div>
            <label class="text-xs font-semibold text-gray-400 tracking-wider mb-1.5 block dark:text-gray-500
                      uppercase">Nueva</label>
            <label class="input w-full">
              <input type="password" placeholder="••••••••" class="grow" />
            </label>
          </div>
          <div>
            <label class="text-xs font-semibold text-gray-400 tracking-wider mb-1.5 block dark:text-gray-500
                      uppercase">Confirmar</label>
            <label class="input w-full">
              <input type="password" placeholder="••••••••" class="grow" />
            </label>
          </div>
        </div>
      </div>
      <div class="mt-5 justify-end flex gap-3">
        <button type="button" class="btn">Cancelar</button>
        <button type="submit" class="btn btn-primary">Guardar Cambios</button>
      </div>
    </div>
  </div>
</div>

